import React from 'react';
import SearchIcon from '../../../images/icon-search.svg';
import styles from '../propertyReport.module.css';

interface SearchBoxProps {
    searchText: string;
    onKeyPress: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onChange: (event: React.FormEvent<HTMLInputElement>) => void;
    placeholderText?: string;
}

const PropertyReportSearchBox: React.FC<SearchBoxProps> = ({ searchText, onKeyPress, onChange, placeholderText }) => {
    return (
        <div className={styles.searchBox}>
            <input
                value={searchText || ''}
                onKeyPress={onKeyPress}
                onChange={onChange}
                type="text"
                placeholder={placeholderText || 'Search for property'}
                maxLength={50}
            />
            <img className={styles.searchIconImage} src={SearchIcon} alt="search-icon" />
        </div>
    );
};

export default PropertyReportSearchBox;
